import request from '@/utils/request'
// 用户信息提交
export function subInfo (data) {
  return request({
    url: '/pla/pc/consult/add',
    method: 'post',
    data
  })
}
